var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncCommands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "250px",
    width: "250px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 362.505 362.505",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 5.437575,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.17503
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22222"
    },
    d: "M102.452,151.928c-17.571,0-31.866,14.295-31.866,31.866s14.295,31.866,31.866,31.866 s31.866-14.295,31.866-31.866S120.023,151.928,102.452,151.928z M102.452,200.661c-9.3,0-16.866-7.566-16.866-16.866 s7.566-16.866,16.866-16.866s16.866,7.566,16.866,16.866S111.752,200.661,102.452,200.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22222"
    },
    d: "M201.265,202.454l-20.681-12.426c0.198-2.184,0.292-4.227,0.292-6.233s-0.095-4.05-0.292-6.232 l20.681-12.426c1.705-1.024,2.933-2.684,3.415-4.614c0.481-1.93,0.176-3.972-0.849-5.677l-28.22-46.969 c-2.133-3.551-6.741-4.701-10.292-2.566c-3.55,2.133-4.699,6.741-2.566,10.291l24.357,40.54l-18.407,11.06 c-2.587,1.555-3.991,4.509-3.561,7.497c0.5,3.479,0.734,6.37,0.734,9.097s-0.233,5.617-0.734,9.097 c-0.43,2.988,0.973,5.942,3.561,7.497l18.407,11.061l-20.495,34.11l-18.403-11.058c-2.592-1.558-5.866-1.406-8.303,0.385 c-4.181,3.071-8.542,5.568-12.961,7.422c-2.787,1.168-4.6,3.895-4.6,6.916v21.381H82.555v-21.381c0-4.143-3.358-7.5-7.5-7.5 s-7.5,3.357-7.5,7.5v28.881c0,4.143,3.358,7.5,7.5,7.5h54.794c4.142,0,7.5-3.357,7.5-7.5v-24.086 c2.462-1.24,4.893-2.634,7.277-4.173l20.693,12.433c3.552,2.133,8.158,0.985,10.292-2.566l28.22-46.968 C205.964,209.195,204.815,204.586,201.265,202.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22222"
    },
    d: "M82.555,118.366V96.985h39.794v21.381c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5V89.485 c0-4.143-3.358-7.5-7.5-7.5H75.055c-4.142,0-7.5,3.357-7.5,7.5v24.086c-2.462,1.239-4.893,2.633-7.277,4.173L39.584,105.31 c-1.706-1.025-3.749-1.33-5.677-0.849c-1.93,0.481-3.59,1.71-4.614,3.415l-28.22,46.969c-2.133,3.55-0.984,8.158,2.566,10.291 l20.68,12.426c-0.198,2.183-0.292,4.226-0.292,6.232s0.095,4.05,0.292,6.233l-20.68,12.426c-3.55,2.134-4.699,6.741-2.566,10.291 l28.22,46.968c1.407,2.342,3.89,3.639,6.436,3.639c1.314,0,2.646-0.346,3.855-1.072c3.55-2.133,4.699-6.741,2.566-10.291 l-24.357-40.539l18.407-11.061c2.587-1.555,3.991-4.509,3.561-7.497c-0.5-3.479-0.734-6.37-0.734-9.097s0.233-5.617,0.734-9.097 c0.43-2.988-0.973-5.942-3.561-7.497l-18.407-11.06l20.495-34.111l18.403,11.058c2.59,1.558,5.865,1.404,8.302-0.384 c4.182-3.071,8.543-5.568,12.962-7.422C80.742,124.114,82.555,121.387,82.555,118.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22222"
    },
    d: "M246.005,125.533l51.473,34.927c1.266,0.859,2.736,1.294,4.211,1.294 c1.203,0,2.409-0.289,3.511-0.873c2.454-1.301,3.988-3.85,3.988-6.627v-27.427h45.816c4.142,0,7.5-3.357,7.5-7.5 s-3.358-7.5-7.5-7.5h-45.816V84.4c0-2.777-1.535-5.326-3.988-6.627c-2.453-1.3-5.424-1.139-7.723,0.421l-51.473,34.927 c-2.057,1.396-3.289,3.72-3.289,6.206S243.948,124.137,246.005,125.533z M294.189,98.552v41.549l-30.616-20.774L294.189,98.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22222"
    },
    d: "M359.216,236.881l-51.473-34.927c-2.297-1.56-5.269-1.722-7.723-0.421s-3.988,3.85-3.988,6.627 v27.427h-45.816c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h45.816v27.427c0,2.777,1.534,5.326,3.988,6.627 c1.102,0.584,2.308,0.873,3.511,0.873c1.475,0,2.946-0.435,4.211-1.294l51.473-34.927c2.057-1.396,3.289-3.72,3.289-6.206 S361.273,238.277,359.216,236.881z M311.032,263.862v-41.549l30.615,20.774L311.032,263.862z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncCommands);
export default __webpack_public_path__ + "static/media/sync-commands.145d17813d6405e0e296e305eb90f78a.svg";
export { ForwardRef as ReactComponent };